var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Untie"},[_c('Header',{attrs:{"msg":"订单绑定"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }